// extracted by mini-css-extract-plugin
export var deliveryRow = "_q8-a";
export var fixedHeight = "_q8-4";
export var freightLogo = "_q8-9";
export var fullWidth = "_q8-3";
export var priceColumn = "_q8-5";
export var radioSelected = "_q8-7";
export var radioUnselected = "_q8-6";
export var selectedOption = "_q8-2";
export var selectedOptionContainer = "_q8-1";
export var selection = "_q8-0";
export var tallSkeletonText = "_q8-8";